import React, { Component, Fragment } from 'react';
import { View, Avatar, Text, Link, isNative, AppHeader } from 'core';
import * as actions from 'actions';
import { theme, style, isMVP } from 'constants';
import { PMFromGroup } from 'selectors';
import { IcoGallery, IcoMute, IcoGroups } from 'icons';
import { lang } from 'lang';

export class PmInfo extends Component {
  render() {
    const { title, member } = this.props;

    return (
      <View style={styles.container}>
        {isNative ? <AppHeader show_connecting back={PMFromGroup() ? 3 : 1} title={title} /> : null}
        <View style={styles.avatar_cont}>
          <Avatar is_large data={member} size={140} />
          <Text style={styles.title}>{title}</Text>
        </View>
        <View style={styles.section_devider} />
        {isMVP ? null : (
          <Fragment>
            <Link style={styles.item_list} onPress={() => console.log('clicked')}>
              <IcoGallery size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
              <Text style={styles.item_text}>{lang.GALLERY}</Text>
            </Link>
            <Link style={styles.item_list} onPress={() => console.log('clicked')}>
              <IcoGroups size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
              <Text style={styles.item_text}>{lang.GROUPS_IN_COMMON}</Text>
            </Link>
            <Link style={styles.item_list} onPress={() => {}}>
              <IcoMute size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
              <Text style={styles.item_text}>{lang.MUTE}</Text>
            </Link>
            <Link style={styles.item_list} onPress={() => {}}>
              <Text style={styles.item_text}>{lang.BLOCK_MEMBER}</Text>
            </Link>
          </Fragment>
        )}
      </View>
    );
  }
}

const styles = style({
  container: {
    backgroundColor: 'white',
    flex: 1
  },
  avatar_cont: {
    marginVertical: 20,
    alignItems: 'center',
    backgroundColor: 'white'
  },
  center: {
    alignSelf: 'center',
    marginVertical: 10
  },
  item_list: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 15
  },
  item_text: {
    color: theme.primary_color
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    margin: 10
  },

  section_devider: {
    backgroundColor: theme.gray_color_lighten(0.05),
    height: 50
  },
  label: {
    color: theme.gray_color_lighten(0.6),
    flex: 1,
    fontSize: theme.font_sm
  }
});



// WEBPACK FOOTER //
// ./src/components/right/pm_info.js